import React from "react";
import { TemplateSectionGridLoader } from "./TemplateSectionGridLoader";
import { TemplateThemeRoot } from "./TemplateThemeRoot";
import type { ThemeTokens } from "./types";
import "./templateSectionGridLoader.css";

function pendingTileCount(cols: number, maxItems?: number): number {
  const rows = 2;
  const cap = cols * rows;
  if (maxItems != null && maxItems > 0) return Math.min(maxItems, cap);
  return cap;
}

/**
 * Light pending grid for shop/content feeds — must not import StayUpToDate.
 */
export function TemplateTabFeedPendingGrid({
  pageVariant,
  device,
  maxItems,
  exiting = false,
  T,
}: {
  pageVariant: "shop" | "content";
  device: "desktop" | "tablet" | "mobile";
  maxItems?: number;
  exiting?: boolean;
  T?: ThemeTokens;
}) {
  const cols = device === "mobile" ? 2 : device === "tablet" ? 3 : 5;
  const grid = (
    <div
      className={[
        "mte-tpl-tab-feed-pending",
        exiting ? "mte-tpl-tab-feed-pending--exit" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-hidden
    >
      <TemplateSectionGridLoader
        variant={pageVariant}
        device={device}
        tileLayout="feed"
        count={pendingTileCount(cols, maxItems)}
      />
    </div>
  );
  if (!T) return grid;
  return (
    <TemplateThemeRoot T={T} className="mte-tpl-tab-feed-pending-theme">
      {grid}
    </TemplateThemeRoot>
  );
}
